import React from "react";
import { Field, Form } from "react-final-form";
import { i18, numberFormat, trb } from "../../../Utilities";
import SelectAdapter from "../../../Components/Forms/SelectAdapter";
import { FormField, FormFieldType } from "../../../Components/FormField";
import { Button } from "antd";

const OrgStructureForm = ({ submitForm, level, parentIndex, parentId }) => {
  const initValues = {
    type: "p",
    title: "",
    share: null
  };

  const handleSubmit = ({ type, title, share }) => {
    if (title && share && type) {
      submitForm(type, title, share, level, parentIndex, parentId);
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={initValues}
      render={({ handleSubmit, submitting }) => {
        return (
          <>
            <form id="orgStructureForm" className="owner-inputs row" onSubmit={handleSubmit}>
              <div className="col-10 pl-4 org-structure-form-col">
                <div className="row org-structure-form-select-row">
                  <div className="col-4 px-2 org-structure-form-col">
                    <Field
                      name="type"
                      component={SelectAdapter}
                      props={{
                        data: {
                          options: [
                            { label: trb(i18.ApplicationsLabels.Person), value: "p" },
                            { label: trb(i18.ApplicationsLabels.Company), value: "c" }
                          ],
                          optionsText: "label",
                          optionsValue: "value",
                          translate: false,
                          noEmpty: true
                        }
                      }}
                      title={trb(i18.ApplicationsLabels.Type)}
                    />
                  </div>
                  <div className="col-4 px-2 org-structure-form-col">
                    <FormField
                      name="title"
                      component={FormFieldType.input}
                      title={trb(i18.ApplicationsLabels.Name)}
                    />
                  </div>
                  <div className="col-4 px-2 org-structure-form-col">
                    <FormField
                      name="share"
                      component={FormFieldType.number}
                      title={trb(i18.ApplicationsLabels.Share)}
                      formatNumber={numberFormat().percent}
                    />
                  </div>
                </div>
              </div>
              <div className="col-2 pl-2 org-structure-form-col org-btn-container">
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  className="btn-big"
                  disabled={submitting}
                >
                  {trb(i18.Buttons.Add)}
                </Button>
              </div>
            </form>
          </>
        );
      }}
    />
  );
};

export default OrgStructureForm;
